"use client";

import React, { useCallback, useState } from "react";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { ITopBanner } from "@/sanity/lib/definitions";

import percentage from "@/public/global/percentage.svg";

export default function TopBanner({ texts }: { texts: ITopBanner }) {
  const [close, setClose] = useState(false);
  const pathname = usePathname();
  const lang =
    pathname.slice(-3) === "/de" || pathname === "/de"
      ? "de"
      : pathname.slice(-3) === "/br" || pathname === "/br"
        ? "br"
        : "en";

  const closeBanner = useCallback(() => {
    document?.getElementById("hero")?.classList?.remove("mt-[16rem]");
    setClose(true);
  }, []);

  if (close) {
    return null;
  }

  return (
    <div className="flex fixed top-0 left-0 z-50 flex-col justify-start items-start w-full lg:flex-row lg:justify-center lg:items-center bg-[#958C7B] h-[14rem] gap-[1rem] px-[2rem] py-[1.55rem] lg:h-[6rem] lg:py-[2rem]">
      <div className="flex gap-[1rem]">
        <Image
          src={percentage}
          alt="percentage"
          className="hidden lg:block !w-[3] !h-[3rem] min-w-[3rem] min-h-[3rem]"
        />
        <span className="text-white">
          {lang === "de"
            ? texts?.de?.text
            : lang === "br"
              ? texts?.br?.text
              : texts?.en?.text}
        </span>
      </div>

      {/* <span className="text-white/70">
        {lang !== "br" ? "CODE:" : "CÓDIGO: "} JANUARYRESET
      </span> */}

      <a
        href={texts?.ctaLink}
        className="text-white underline transition-opacity hover:opacity-70"
      >
        {lang === "de"
          ? texts?.de?.ctaText
          : lang === "br"
            ? texts?.br?.ctaText
            : texts?.en?.ctaText}
      </a>
    </div>
  );
}
